import React from "react";
import { Toolbar, ToolbarButton, Icon } from "react-onsenui";
import ConditionalBackButton from "./ConditionalBackButton";
import ShareUrlButton from "./ShareUrlButton";

export default class ToolbarOur extends React.Component {
  handleClose = () => {
    // Close the page (this could be a different function depending on your setup)
    window.close(); // or any other method to close the page
  };

  render() {
    return (
      <Toolbar>
        <div className="left">
          <ShareUrlButton size={16} />
          <ConditionalBackButton navigator={this.props.navigator} />
        </div>

        <div className="center">{this.props.pageName}</div>

        <div className="right">
          <ToolbarButton onClick={this.handleClose} className="clickable">
            <Icon icon="zmdi-close" size={20} />
          </ToolbarButton>

          {this.props.showMenu && (
            <ToolbarButton
              onClick={() => this.props.showMenu()}
              className="clickable"
            >
              <Icon icon="md-help-outline" size={20} />
            </ToolbarButton>
          )}
          
          {/* Add this button */}
          {this.props.onAboutUsTrigger && (
            <ToolbarButton
              onClick={this.props.onAboutUsTrigger}
              className="clickable"
            >
              <Icon icon="md-chevron-left" size={20} />
            </ToolbarButton>
          )}
        </div>
      </Toolbar>
    );
  }
}
